import { css } from '@linaria/core';
export const wrapper = "omponents__EntityCard__ClarifaiLogoItem_styled_ts-wrapper-w1ng6ecl";
export const userLetterIcon = "omponents__EntityCard__ClarifaiLogoItem_styled_ts-userLetterIcon-u18eds3a";
export const iconWrapper = "omponents__EntityCard__ClarifaiLogoItem_styled_ts-iconWrapper-ikejjv1";
export const textWrapper = "omponents__EntityCard__ClarifaiLogoItem_styled_ts-textWrapper-t1vw86t9";

require("./ClarifaiLogoItem.styled.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./ClarifaiLogoItem.styled.ts");